<template>
  <div>
    <div v-if="$route.name.includes('hyundai')">
      <hyundai-header />
      <hyundai-body />
    </div>
    <div v-else-if="$route.name.includes('dlcon')">
      <dlcon-header />
      <dlcon-body />
    </div>
    <div v-else>
      <!-- 220615 배너 제거
      <div v-if="['report'].includes($route.name) && showPopupBanner" class="popup-banner">
        <v-card>
          <v-img src="./assets/banner/report_quarter.png" @click="onClickPopupBanner"></v-img>
          <v-card-actions class="ma-0 pa-0">
            <div>
              <v-checkbox
                  v-model="popupBannerHide"
                  hide-details
                  style="margin-top:-12px;margin-bottom:-6px;"
              >
                <template v-slot:label>
                  <div class="today-hide">오늘 하루 보지 않기</div>
                </template>
              </v-checkbox>
            </div>
            <v-spacer></v-spacer>
            <v-btn text @click="showPopupBanner=false" class="popup-close">닫기</v-btn>
          </v-card-actions>
        </v-card>
      </div> -->

      <!-- <div v-if="['home'].includes($route.name) && showPopupBanner3" class="popup-banner">
        <v-card>
          <v-img src="./assets/main/popup-banner3.jpg" @click="onClickPopupBanner3"></v-img>
          <v-card-actions class="ma-0 pa-0">
            <div>
              <v-checkbox
                v-model="popupBannerHide3"
                hide-details
                style="margin-top:-12px;margin-bottom:-6px;"
              >
                <template v-slot:label>
                  <div class="today-hide">오늘 하루 보지 않기</div>
                </template>
              </v-checkbox>
            </div>
            <v-spacer></v-spacer>
            <v-btn text @click="showPopupBanner3=false" class="popup-close">닫기</v-btn>
          </v-card-actions>
        </v-card>
      </div> -->

      <v-app class="expert-version-shell" :class="presentation.renewed ? 'expert-renewal' : ''" style="background-color:#FAFAFA">
        <version-tabs />
        <expert-header v-if="presentation.renewed" />
        <layout-appbar v-else class="appbar" />
        <v-btn
            v-if="!presentation.renewed && showRichgoMobileBanner && (isRealestateView || isEconomyView)"
            class="ma-2 drawer-menu-button"
            color="primary"
            large
            @click.stop="showDrawer(!drawer)"
            rounded
        >
          <v-icon large>mdi-format-list-bulleted-square</v-icon>
        </v-btn>
        <v-btn
            v-else-if="!presentation.renewed && !showRichgoMobileBanner && (isRealestateView || isEconomyView)"
            class="ma-2 drawer-menu-button2"
            color="primary"
            large
            @click.stop="showDrawer(!drawer)"
            rounded
        >
          <v-icon large>mdi-format-list-bulleted-square</v-icon>
        </v-btn>

        <layout-drawer
            key="realestate"
            title="리치고 부동산"
            name="realestate"
            v-if="isRealestateView && (!presentation.renewed || $route.params.tableauId)"
            :initial-open="!presentation.renewed"
        ></layout-drawer>
        <layout-drawer
            key="economy"
            title="리치고 경제"
            name="economy"
            v-else-if="isEconomyView && (!presentation.renewed || $route.params.tableauId)"
            :initial-open="!presentation.renewed"
        ></layout-drawer>
        <layout-view></layout-view>
        <layout-footer></layout-footer>
      </v-app>
    </div>


  </div>
</template>

<script>
import { presentation } from './renewal/presentation';
import ExpertHeader from './renewal/ExpertHeader.vue';
import VersionTabs from './renewal/VersionTabs.vue';
import LayoutAppbar from "./layouts/appbar2";
import LayoutDrawer from "./layouts/drawer";
import LayoutView from "./layouts/view";
import LayoutFooter from "./layouts/footer";
import { mapState, mapMutations, mapActions } from "vuex";
import HyundaiHeader from "./layouts/b2b/hyundai/hyundaiHeader";
import HyundaiBody from "./layouts/b2b/hyundai/hyundaiBody";
import DlconHeader from "./layouts/b2b/dlcon/dlconHeader";
import DlconBody from "./layouts/b2b/dlcon/dlconBody";


export default {
  created() {
    this.showPopupBanner = true;
    this.showPopupBanner3 = false;
    const popupBannerHide = localStorage.getItem("popupBannerHide");
    const popupBannerHide3 = localStorage.getItem("popupBannerHide3");
    if (popupBannerHide && Date.now() < popupBannerHide) {
      this.showPopupBanner = false;
    } else {
      this.showPopupBanner = true;
    }

    if (popupBannerHide3 && Date.now() < popupBannerHide3) {
      this.showPopupBanner3 = false;
    } else {
      this.showPopupBanner3 = true;
    }

    window.addEventListener("storage", this.handleStorageChanged);
  },
  destroyed() {
    window.removeEventListener("storage", this.handleStorageChanged);
  },
  data() {
    return {
      presentation,
      topBanner: require("./assets/main/open-event-banner.png"),
      showPopupBanner: true,
      showPopupBanner3: true,
      popupBannerHide: false,
      popupBannerHide2: false,
      popupBannerHide3: false
    };
  },
  computed: {
    ...mapState([
      "profile",
      "drawer",
      "showRichgoMobileBanner"
    ]),
    isRealestateView() {
      return this.$route.name === "realestate";
    },
    isEconomyView() {
      return this.$route.name === "economy";
    }
  },
  methods: {
    ...mapMutations([
      "showDrawer",
      "logout",
      "setRefreshTokenWithoutStorageUpdate",
      "setAccessTokenWithoutStorageUpdate"
    ]),
    ...mapActions(["updateLoggedin"]),
    onClickBanner() {
      this.$router.push("/pricing");
    },
    onClickPopupBanner() {
      // window.open("https://www.youtube.com/channel/UC3nsb3SxlRrJQ9egkKNnlfg");
    },
    onClickPopupBanner3() {
      window.open("https://www.richgo.ai");
    },
    async handleStorageChanged(evt) {
      if (evt.key === "refreshToken") {
        if (evt.newValue === null) {
          this.logout(false);
        } else {
          this.setRefreshTokenWithoutStorageUpdate(evt.newValue);
        }
        await this.updateLoggedin();
      }
      if (evt.key === "accessToken") {
        if (evt.newValue === null) {
          // do nothing
        } else {
          this.setAccessTokenWithoutStorageUpdate(evt.newValue);
        }
      }
    }
  },
  watch: {
    popupBannerHide: {
      handler: function(v) {
        if (v) {
          let d = new Date();
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
          d.setDate(d.getDate() + 1);
          localStorage.setItem("popupBannerHide", d.getTime());
        }
      }
    },
    popupBannerHide2: {
      handler: function(v) {
        if (v) {
          let d = new Date();
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
          d.setDate(d.getDate() + 1);
          localStorage.setItem("popupBannerHide2", d.getTime());
        }
      }
    },
    popupBannerHide3: {
      handler: function(v) {
        if (v) {
          let d = new Date();
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
          d.setDate(d.getDate() + 1);
          localStorage.setItem("popupBannerHide3", d.getTime());
        }
      }
    },
  },
  name: "App",
  components: {
    ExpertHeader,
    VersionTabs,
    DlconHeader,
    DlconBody,
    HyundaiBody,
    HyundaiHeader,
    LayoutAppbar,
    LayoutDrawer,
    LayoutView,
    LayoutFooter
  }
};
</script>

<style scoped>
.appbar {
  position: relative;
  top: 0;
  z-index: 2;
}
.top-banner:hover {
  cursor: pointer;
}

.popup-banner {
  position: absolute;
  top: 100px;
  right: 100px;
  z-index: 10;
  width: 500px;
  border: 1px solid black;
}

.popup-banner:hover {
  cursor: pointer;
}

.today-hide {
  color: black;
  font-size: 0.875rem;
}

.popup-close {
  margin-top: -10px;
  margin-bottom: -6px;
  font-size: 0.875rem;
}

.drawer-menu-button {
  position: fixed;
  top: 110px;
  left: 20px;
  z-index: 3;
  border: none;
  border-radius: 25px;
  outline: none;
  background: #4caf50;
}

.drawer-menu-button2 {
  position: fixed;
  top: 50px;
  left: 20px;
  z-index: 3;
  border: none;
  border-radius: 25px;
  outline: none;
  background: #4caf50;
}

@media only screen and (max-width: 600px) {
  .popup-banner {
    top: 5%;
    right: 5%;
    width: 90%;
  }

  .today-hide {
    font-size: 0.7rem;
  }

  .popup-close {
    font-size: 0.7rem;
  }
}

@media only screen and (max-width: 720px) {
  .drawer-menu-button {
    display: fixed;
    top: -3px;
  }
  .drawer-menu-button2 {
    display: fixed;
    top: -3px;
  }
}

</style>
